import Client from "./Client";
import Survey from "Class/Survey";
import { AnyObject } from "types";
import { format } from "date-fns";
const resource = "/surveys";

type Filter = {
  startDate: Date | null;
  endDate: Date | null;
  userId: number;
};

export default class SurveyService {
  public static async getSurveys(
    page: number,
    size: number
  ): Promise<AnyObject> {
    const { data } = await Client.get(`${resource}`);
    return data;
  }
  public static async getSurvey(surveyId: number): Promise<Survey> {
    const { data } = await Client.get(`${resource}/${surveyId}?edit=true`);
    return new Survey(data.data);
  }
  public static async getSurveyByUuid(uuid: string): Promise<Survey> {
    try {
      const { data } = await Client.get(`${resource}/survey_web/${uuid}`);
      return new Survey(data.data);
    } catch (e) {
      if (e.error) throw e.error;
      if (e.detail) throw e.detail;
      throw e;
    }
  }
  public static async saveSurvey(
    survey: Survey,
    campaignId: number
  ): Promise<AnyObject> {
    if (survey.id === 0) {
      survey.campaignId = campaignId;
      const created = await Client.post(`${resource}`, survey.asJSON());
      return created.data;
    } else {
      const updated = await Client.put(
        `${resource}/${survey.id}`,
        survey.asJSON()
      );
      return updated.data;
    }
  }
  public static async getMembersEmail(surveyId: number): Promise<AnyObject> {
    const { data } = await Client.get(`${resource}/${surveyId}/members_email`);
    return data;
  }

  public static async getSurveyEmails(
    surveyId: number,
    page: number,
    size: number
  ): Promise<AnyObject> {
    const url = `${resource}/${surveyId}/survey_emails?page=${page}&page_size=${size}`;
    const { data } = await Client.get(url);
    return data;
  }

  public static async sendEmails(
    surveyId: number,
    message: string,
    emails: Array<string>
  ): Promise<AnyObject> {
    const emails_data = { message, emails };
    const send = await Client.post(
      `${resource}/${surveyId}/send_emails`,
      emails_data
    );
    return send;
  }
  public static async exportCSV(
    surveyId: number,
    filters: Filter = { startDate: null, endDate: null, userId: 0 }
  ): Promise<ArrayBuffer> {
    const url = this.createUrl(surveyId, "export_csv", filters);
    const response = await Client.get(url, { responseType: "arraybuffer" });
    return response.data;
  }
  public static async download(
    surveyId: number,
    filters: Filter = { startDate: null, endDate: null, userId: 0 }
  ): Promise<ArrayBuffer> {
    const url = this.createUrl(surveyId, "download", filters);
    const response = await Client.get(url, { responseType: "arraybuffer" });
    return response.data;
  }
  public static async removeSurvey(surveyId: number): Promise<void> {
    await Client.delete(`${resource}/${surveyId}`);
  }

  private static createUrl(
    surveyId: number,
    destiny: string,
    filters: Filter
  ): string {
    let url = `${resource}/${surveyId}/${destiny}`;
    let filterDate = false;
    if (filters.startDate && filters.endDate) {
      url += `?start_date='${format(
        filters.startDate,
        "yyyy/MM/dd"
      )}'&end_date='${format(filters.endDate, "yyyy/MM/dd")}'`;
      filterDate = true;
    }
    if (filters.userId) {
      url += `${filterDate ? "&" : "?"}user=${filters.userId}`;
    }
    return url;
  }
}
